import { FC, useContext } from 'react';
import styled from 'styled-components';

import { getImage } from '@/lib/fetchAPI';
import { parseHTML } from '@/lib/parse';
import { translate } from '@/lib/translate';
import { GlobalContext } from '@/pages/_app';

const AdvantageItem: FC<any> = ({ advantage, index }) => {
	const { lang } = useContext(GlobalContext);

	const iconTitle = translate(lang, {
		en: `Viber Services to Promote Your Business Advantage ${index + 1}`,
		ru: `Сервисы Viber для продвижения вашего бизнеса Преимущества ${
			index + 1
		}`,
		ua: `Сервіси Viber для просування вашого бізнесу Переваги ${index + 1}`,
	});

	return (
		<Item>
			<div>
				<Icon alt={iconTitle} src={getImage(advantage?.icon)} />
			</div>

			<div>
				<Title>{parseHTML(advantage.title)}</Title>

				<Paragraph>{parseHTML(advantage.description)}</Paragraph>
			</div>
		</Item>
	);
};

const Item = styled.div`
	display: flex;
	align-items: flex-start;
	height: 100%;
	background: rgba(205, 201, 227, 0.1);
	border: 1px solid #fff;
	border-radius: 70px;
	padding: 8px 50px 62px 8px;

	@media (max-width: 1000px) {
		padding: 8px 40px 52px 8px;
	}

	@media (max-width: 600px) {
		border-radius: 40px;
	}
`;

const Icon = styled.img`
	width: 120px;

	@media (max-width: 1150px) {
		width: 120px;
	}

	@media (max-width: 1050px) {
		width: 115px;
	}

	@media (max-width: 1000px) {
		width: 100px;
	}

	@media (max-width: 600px) {
		width: 80px;
	}
`;

const Title = styled.h3`
	max-width: 220px;
	font-family: var(--font-sans);

	font-size: 28px;
	line-height: 35px;
	color: var(--color-black);
	margin-top: 47px;

	@media (max-width: 1150px) {
		font-size: 26px;
	}

	@media (max-width: 1000px) {
		margin-top: 30px;
		font-size: 26px;
	}

	@media (max-width: 600px) {
		font-size: 22px;
		line-height: 25px;
	}
`;

const Paragraph = styled.div`
	max-width: 260px;
	font-family: var(--font-sans);

	font-size: 18px;
	line-height: 25px;
	color: var(--color-black);
	margin-top: 15px;

	@media (max-width: 1150px) {
		font-size: 17px;
	}

	@media (max-width: 1000px) {
		font-size: 16px;
		line-height: 28px;
	}

	@media (max-width: 600px) {
		font-size: 16px;
		line-height: 25px;
	}
`;

export default AdvantageItem;
